module.exports = __webpack_public_path__ + "static/media/icon_03.a50fe801.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_03.png
// module id = 1644
// module chunks = 1